import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { calcIncludingTax } from '../../../../../helpers/calc/tax';
import { propNumber } from '../../../../../helpers/custom-prop-types';
const SlideSearchPlanPrice = (props) => {
    const { price } = props;
    const hasPrice = typeof price !== 'undefined';
    const isGtZero = price > 0;
    return (_jsxs("div", Object.assign({ className: 'slide_search_plan_price' }, { children: [hasPrice && _jsx("span", Object.assign({ className: 'price_monthly' }, { children: "\u6708\u984D" })), _jsx("span", Object.assign({ className: clsx('price_number', isGtZero && 'active', hasPrice && !isGtZero && 'zero', !hasPrice && 'string') }, { children: hasPrice ? calcIncludingTax(price).toLocaleString() : '---' })), hasPrice && (_jsx("span", Object.assign({ className: 'price_unit' }, { children: `円${isGtZero ? '（税込）' : ''}` })))] })));
};
SlideSearchPlanPrice.propTypes = {
    price: propNumber(),
};
SlideSearchPlanPrice.defaultProps = {
    price: undefined,
};
export default SlideSearchPlanPrice;
